import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import ExtendLetter from "./ExtendLetter";
export const ShowLetter = () => {
  const { id } = useParams();

  return (
    <Box className="pt-0 md:pt-12 w-full h-full flex flex-col">
      <ExtendLetter row={{ id, onUpdate: () => {}, onDelete: () => {} }} />
    </Box>
  );
};
